<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <supermercados-table />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import SupermercadosTable from "./components/SupermercadosTable.vue";

export default {
  name: "Supermercados",
  components: {
    AuthenticatedLayout,
    SupermercadosTable,
  },
};
</script>
